<template>
  <div class="favorite-search">
    <el-select v-model="filterKey" class="left" filterable @change="changeSearchKey">
      <el-option
        v-for="item in searchList"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
    <el-input
      class="right"
      clearable
      v-if="filterKey === 'description'"
      v-model="searchInfo"
      @input="searchData"
    ></el-input>
    <normal-select
      class="right"
      filterable
      v-else-if="filterKey === 'appId'"
      :select-list="appList"
      :selected-item.sync="searchInfo"
      @update:selectedItem="searchData"
    ></normal-select>
    <tree-select
      class="right"
      v-else-if="filterKey === 'sheetId'"
      :group-list="sheetGroupList"
      v-model="searchInfo"
      @input="searchData"
    ></tree-select>
    <div class="icon-search-box" @click="searchData">
      <i class="el-icon-search"></i>
    </div>
  </div>
</template>
<script>
import { searchableInfos } from "@/views/Company/Todo/static"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import { getAppList } from "@/api/userCenter/app"
import { getCompanySheets } from "@/api/sheet/sheet"
import TreeSelect from "@/components/UIComponents/TreeSelect"

export default {
  name: "FavoriteSearch",
  components: { TreeSelect, NormalSelect },
  props: { appId: String },
  data() {
    return {
      searchableInfos,
      searchInfo: "",
      filterKey: "",
      appList: [],
      sheetGroupList: []
    }
  },
  computed: {
    searchList() {
      return this.appId ? this.searchableInfos.slice(1) : this.searchableInfos
    }
  },
  created() {
    this.getSearchData()
  },
  methods: {
    getSearchData() {
      if (this.appId) {
        this.filterKey = "sheetId"
        getCompanySheets().then(appList => {
          let curApp = appList.find(app => this.appId === app.id)
          this.initSheetGroup([curApp])
        })
      } else {
        this.filterKey = "appId"
        getAppList("MEMBER").then(res => {
          this.appList = res.map(app => ({
            label: app.name,
            value: app.id
          }))
          let appIds = res.map(app => app.id)
          getCompanySheets().then(appList => {
            let filterAppList = appList.filter(app => appIds.includes(app.id))
            this.initSheetGroup(filterAppList)
          })
        })
      }
    },
    initSheetGroup(availableSheets) {
      this.sheetGroupList = Object.freeze(
        availableSheets.map(app => ({
          label: app.name,
          options: app.sheets.map(sheet => ({
            label: sheet.name,
            value: sheet.sheetId
          }))
        }))
      )
    },
    changeSearchKey(key) {
      this.filterKey = key
      this.searchInfo = ""
    },
    searchData() {
      this.$emit("search", this.filterKey, this.searchInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
.favorite-search {
  display: flex;
  width: 360px;
  .left {
    width: 100px;
    flex-shrink: 0;
    ::v-deep {
      .el-input.is-focus .el-input__inner {
        border-color: #dcdfe6;
      }
      .el-input__inner {
        border-radius: 4px 0 0 4px;
        border-right: none;
        &:hover,
        &:focus {
          border-color: #dcdfe6;
        }
      }
    }
  }
  .icon-search-box {
    @include flex-center;
    background-color: #f5f7fa;
    color: #909399;
    border: 1px solid #dcdfe6;
    border-left: none;
    border-radius: 0 4px 4px 0;
    padding: 0 12px;
    font-size: 14px;
    cursor: pointer;
  }
  .right {
    flex: 1;
    ::v-deep {
      .el-input__inner {
        border-radius: unset !important;
      }
    }
  }
}
</style>
